module.exports = __webpack_public_path__ + "media/images/emblems/La_Roche-coat_of_arms-5f9f3b394659c171ab3da5e0e17262e0.svg";